import { render, staticRenderFns } from "./WidgetPreview.vue?vue&type=template&id=42b0f488&"
import script from "./WidgetPreview.vue?vue&type=script&lang=js&"
export * from "./WidgetPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports